/** Raw compilation supplies its entire environment. Page readers retain their
 * normal host outside compilation; workers never consult a page or its DOM. */
export interface CompileAmbient {
    FateTide?: unknown;
    ftCreatorCharacter?: unknown;
    ftFindFullNestedItem?: unknown;
    ftLayerValue?: unknown;
    ftStatusEffectPermanentUuids?: unknown;
    ftRequireInventoryBase?: unknown;
    ftBaseCommitsPaused?: unknown;
    parent?: unknown;
    __ft3dCampaignPlacementAuthority?: unknown;
}
let inputs: CompileAmbient | undefined;
export function setCompileAmbient(value: CompileAmbient): void { inputs = value; }
export function compileAmbient(): CompileAmbient { return inputs ?? globalThis as CompileAmbient; }
export function hasCompileAmbient(): boolean { return inputs !== undefined; }
